var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.298 19.451a.994.994 0 01-.3-.703.922.922 0 01.28-.702L17.322 11H1.846a.968.968 0 01-.712-.287A.968.968 0 01.846 10c0-.284.096-.522.288-.713A.968.968 0 011.846 9h15.477l-7.046-7.046a.922.922 0 01-.28-.703.993.993 0 01.3-.702.957.957 0 01.703-.29c.275 0 .51.096.703.29l8.608 8.607c.124.111.212.24.264.385a1.37 1.37 0 010 .901c-.052.143-.14.277-.264.401l-8.608 8.608a.957.957 0 01-.703.29.957.957 0 01-.702-.29z",
    fill: "currentColor"
  })));
}
export default SvgArrowRight;